export default __webpack_public_path__ + "static/media/7.29a0e8f8.png";